<template>
    <div class='invite-dialog dialog-bg'>
        <div class="invite-content">
            <div class="invite-top"></div>
            <div class="invite-middle">
                <div v-if="inviteResult.code !== 200">
                    <div class="invite-fail">邀请失败</div>
                    <div class="subtitle">{{ inviteResult.msg }}</div>
                </div>
                <div v-else>
                    <div class="invite-suc">
                        <span class="number-font">{{ inviteResult.credits }}</span>积分
                    </div>
                    <div class="subtitle">您已为好友<span class="username">{{ inviteResult.nickname }}</span>助力！</div>
                </div>
            </div>
            <div class="big-btn" @click="$emit('close')">{{ inviteResult.code !== 200 ? '知道了' : '游玩积分' }}</div>
            <div class="close" @click="$emit('close')"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'rule-dialog',
    components: {},
    props: {
        inviteResult: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
        }
    },
    mounted() {
        Report.click({
            value: '{"evt": "' + 5048 + '"}',
        })
    },
    methods: {
    },
}
</script>
<style scoped lang='less'>
.invite-content {
    width: 570px;
    height: 500px;
    border-radius: 20px;
    background-color: #fff;
    text-align: center;
    position: relative;

    .invite-top {
        margin-top: -60px;
        height: 200px;
        background-image: url('../../assets/coin-top.png');
        background-size: 100% auto;
    }

    .invite-middle {
        height: 200px;
        padding-top: 30px;
    }

    .invite-fail {
        font-size: 44px;
        font-weight: 600;
        color: #141516;
        line-height: 54px;
    }

    .invite-suc {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        line-height: 46px;

        .number-font {
            margin-right: 10px;
            font-size: 50px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #000000;
            line-height: 46px;
        }
    }

    .subtitle {
        padding-top: 40px;
        font-size: 28px;
        font-weight: 400;
        color: #000000;
        line-height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .username {
        display: inline-block;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .invite-close-btn {
        margin: 20px auto;
        width: 490px;
        height: 90px;
        background: linear-gradient(270deg, #FF7B00 0%, #FF4500 100%);
        border-radius: 12px;
        font-size: 30px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 0;
        padding-top: 42px;
    }
}
</style>
